module.exports = function() {
  return new Worker(__webpack_public_path__ + "8f8c9ab5118b95e37a6c.worker.js");
};